import { Panel } from "react-resizable-panels";
import styled from "@emotion/styled";

export const MDSPanel = styled(Panel)`
  position: relative;
  container-type: inline-size;
  container-name: mds-panel;
`;
